import Port from "./port";

export default function portFromJson(json) {
    return new Port(
        json.code,
        json.countryCode,
        json.name,
        json.lat,
        json.lon,
        json.locode,
    )
}